export interface ISimpleTabeGridColumns {
    field?: string;
    headerName?: string;
    valueFormatter?(data: any): any;
}
export interface ISimpleTable {
    gridColumns?: Array<ISimpleTabeGridColumns>;
    rowData?: Array<any>;
}
const SimpleTable = (props: ISimpleTable) => {
    const { gridColumns, rowData } = props;
    return (
        <div className="simpletableWrapper">
            <table>
                <thead>
                    <tr>
                        {gridColumns?.map((header, index) => (
                            <th key={index}>{header.headerName}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rowData?.map((data, indexRow) => (
                        <tr key={indexRow}>
                            {gridColumns?.map((header, indexCell) => {
                                const field = header.valueFormatter
                                    ? header.valueFormatter({ data })
                                    : data[header.field || ""];
                                return <td key={indexCell}>{field}</td>;
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SimpleTable;
